import { PacketOut } from "./PacketOut.js";
import { OutboundPacketType } from "./OutboundPacketType.js";
import type { MessageIOContext } from "../../../api/MessageIOContext.js";


export class PacketOutRefreshUser extends PacketOut {

    constructor() {
        super(OutboundPacketType.REFRESH_USER);
    }

    override writeContents(_context: MessageIOContext): Record<string, any> {
        // Nothing to write.
        return {};
    }
}
